import { render, staticRenderFns } from "./AiReasonBnr.vue?vue&type=template&id=7c2edede&scoped=true"
import script from "./AiReasonBnr.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiReasonBnr.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AiReasonBnr.vue?vue&type=style&index=0&id=7c2edede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2edede",
  null
  
)

export default component.exports